import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { EmploymentActions } from './employment.actions';

@Injectable({
  providedIn: 'root'
})
export class EmploymentEffects {
  sendEmploymentEffect$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(EmploymentActions.submitSuccess),
        tap(() => {})
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}
}
